// extracted by mini-css-extract-plugin
module.exports = {"noPost":"SmallPostsListSection_noPost__QmP_M","post":"SmallPostsListSection_post__CZqn7"};